import { sumPxWidths } from './suppliersBalanceColumnWidths'

/** Debit, Credit and Balance — fits a negative 11-digit figure (-10,000,000,000.00), measured at 143px in Inter 14px plus 20px cell padding. */
export const LEDGER_ENTRIES_AMOUNT_COLUMN_WIDTH = '164px'

/** Description has no fixed width (absorbs leftover). Encoded in the table min-width — cell min-width is ignored under `table-layout: fixed`. Kept low on purpose so horizontal scroll starts as late as possible. */
export const LEDGER_ENTRIES_DESCRIPTION_MIN_WIDTH = '160px'

/** Journal holds an abbreviated header plus a truncating tag; Document number truncates with a tooltip. Date is above Figma 80px so localized short dates stay on one line. */
export const LEDGER_ENTRIES_COLUMN_WIDTHS = {
  date: '112px',
  journal: '80px',
  documentNumber: '140px',
  amount: LEDGER_ENTRIES_AMOUNT_COLUMN_WIDTH,
} as const

/** Fixed columns + Description leftover floor — enables horizontal scroll on small viewports. */
export const LEDGER_ENTRIES_TABLE_MIN_WIDTH = sumPxWidths(
  LEDGER_ENTRIES_COLUMN_WIDTHS.date,
  LEDGER_ENTRIES_COLUMN_WIDTHS.journal,
  LEDGER_ENTRIES_DESCRIPTION_MIN_WIDTH,
  LEDGER_ENTRIES_COLUMN_WIDTHS.documentNumber,
  LEDGER_ENTRIES_COLUMN_WIDTHS.amount,
  LEDGER_ENTRIES_COLUMN_WIDTHS.amount,
  LEDGER_ENTRIES_COLUMN_WIDTHS.amount,
)
